import { configureStore } from '@reduxjs/toolkit';
import socketioReducer from '../features/socketioSlice';
import layoutReducer from '../features/layoutSlice';

export default configureStore({
	reducer: {
		socketio: socketioReducer,
		layout: layoutReducer,
	},
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});
